<script lang="ts">
  import { currentQuestion, surveyStatus } from '../../stores'

  let current =
    $surveyStatus.currentUserAnswer.length > 0 ? $surveyStatus.currentUserAnswer[0].text : null

  $: {
    $surveyStatus.currentUserAnswer = current
      ? [{ ...$currentQuestion.answers[0], text: current }]
      : []
    $surveyStatus = $surveyStatus
  }
</script>

<svelte:window
  on:keydown={(event) => {
    if (event.key === 'ArrowRight' && event.altKey) {
      event.preventDefault()
      current = '55'
    }
  }}
/>

<label>
  <input
    type="number"
    on:keydown={(event) => {
      // Allow only numbers
      if (!RegExp(/[0-9]/g).test(event.key)) {
        event.preventDefault()
      }
    }}
    on:keyup={(event) => {
      if (parseInt(current) > 1000) {
        event.preventDefault()
        current = '1000'
        alert('Inserisci un numero tra 0 e 1000')
      }
    }}
    min="0"
    max="1000"
    step="1"
    placeholder="Inserisci una distanza in km"
    bind:value={current}
  />
</label>

<style>
  input {
    width: 100%;
    background-color: transparent;
    border: 0;
    border-bottom: 1px solid white;
    border-radius: 0;
    color: white;
  }
  input:focus-visible {
    outline: 0;
  }
  input::placeholder {
    color: #7b7b7b;
  }
</style>
